import { catalogControlsFromDocument, cloneCatalogControls, valueAt } from "../catalogDocument.js";
import { POINTERS } from "./help.js";

export const cloneCopilotControls = cloneCatalogControls;
export const copilotControlsFromDocument = catalogControlsFromDocument;
export const composeCopilotDocument = (controls) => JSON.parse(JSON.stringify(controls.document));
export const copilotDerivedValues = () => ({});

const isEmptyList = (value) => !Array.isArray(value) || value.length === 0;

/// Lists the server would refuse as written: Require SSO with no
/// organization or domain, and a locked-kinds list with no kind.
export function copilotIncompleteLists(controls) {
    const incomplete = [];
    const remote = valueAt(controls.document, POINTERS.remoteControl);
    if (remote?.mode === "requireSSO" && isEmptyList(remote.githubDotComOrganizations) && isEmptyList(remote.githubEnterpriseCloudDomains)) {
        incomplete.push("Remote control organizations or domains");
    }
    const surfaces = valueAt(controls.document, POINTERS.pluginOnly);
    if (Array.isArray(surfaces) && !surfaces.length) incomplete.push("plugin-only customization kinds");
    return incomplete;
}
